import React from 'react'
import PropTypes from 'prop-types'
import { connect, useStore } from 'react-redux'

import { Button } from '@resurs/midas-react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

import { logout } from '../../../store/actions/auth-actions'
import { dismiss, notify } from '../../../store/actions/notification-actions'
import { resetTransactions } from '../../../store/actions/transactions-actions'
import { NOTIFY_PRIMARY } from '../../../store/actions/action-types'

import { getText } from '../../TextLabels'

import ChatContainer from '../../../containers/Chat/ChatContainer'

import styles from './Header.module.scss'

const Header = props => {
  const store = useStore()
  const userId = store.getState().auth.userId
  const seenChatList =
    JSON.parse(localStorage.getItem('chat_notification_dismissed')) ?? []
  const seenChat = seenChatList.includes(userId)

  const chatCallToActionContent = () => {
    return (
      <div className={styles.chatNotification}>
        <FontAwesomeIcon icon={faArrowUp} size="lg" />
        {getText('general.chatCallToAction')}
      </div>
    )
  }

  const setChatDismissed = () => {
    seenChatList.push(userId)
    localStorage.setItem(
      'chat_notification_dismissed',
      JSON.stringify(seenChatList),
    )
  }

  const handleLogout = e => {
    e.preventDefault()
    dismiss('chatCallToAction')
    props.logout()
    props.resetTransactions()
  }

  return (
    <div
      style={{
        position: 'fixed',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'row',
        alignItems: 'center',
        left: props.menuOpen ? '256px' : '56px',
        right: 0,
        height: props.menuOpen ? '69px' : '48px',
        borderBottom: '1px solid #ddd',
        padding: props.menuOpen ? '1.6rem 2.4rem' : '.5rem 2.4rem',
        background: 'white',
        transition: 'width .4s ease, padding .3s ease, left .4s ease',
        zIndex: '999',
      }}
    >
      {props.isLoggedIn &&
        !seenChat &&
        notify(
          NOTIFY_PRIMARY,
          chatCallToActionContent(),
          true,
          setChatDismissed,
          'chatCallToAction',
        )}

      <h4 style={{ margin: 0, padding: 0 }}>{getText('siteTitle')}</h4>
      <div style={{ flexGrow: 1 }} />
      <ChatContainer />
      <div style={{ paddingTop: '.3rem' }}>
        <Button
          size="small"
          type="normal"
          dataCy="logout-button"
          onClick={e => handleLogout(e)}
        >
          {getText('menu.header.logout')}
        </Button>
      </div>
    </div>
  )
}

Header.propTypes = {
  menuOpen: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  resetTransactions: () => dispatch(resetTransactions()),
})

export default connect(null, mapDispatchToProps)(Header)
